<template>
	<div class="d-inline-block">
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn v-bind="attrs" v-on="on" small color="success" @click="dialogPlace = true">
					<v-icon left>mdi-plus</v-icon>
					<v-icon small left>mdi-home-group</v-icon>
				</v-btn></template
			>
			<span>Cree nuevos establecimientos donde usted administra actividades en el.</span>
		</v-tooltip>
		<v-dialog v-model="dialogPlace" transition="dialog-bottom-transition" max-width="800">
			<v-card>
				<v-toolbar color="primary" flat dark>
					Nuevo establecimiento
					<v-spacer></v-spacer>
					<v-btn text fab @click="dialogPlace = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-toolbar>
				<v-card-text><place-form :close="() => (dialogPlace = false)"/></v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	components: {
		PlaceForm: () => import('@/components/place/PlaceForm'),
	},
	data() {
		return {
			dialogPlace: false,
		};
	},
};
</script>
